import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import PasswordGate from './components/PasswordGate';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PasswordGate>
      <App />
    </PasswordGate>
  </React.StrictMode>,
);
